import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '../../base/ui/components/web/Dialog';
import { translate } from '../../base/i18n/functions';
import i18next, { DEFAULT_LANGUAGE, LANGUAGES } from '../../base/i18n//i18next';
import Select from '../../base/ui/components/web/Select';
/**
 * Component that renders the language dialog.
 *
 * @returns {React$Element<any>}
 */
class LanguageDialog extends Component {
    /**
     * Instantiates a new component.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this.state = {
            currentLanguage: i18next.language || DEFAULT_LANGUAGE,
            newLanguage: i18next.language || DEFAULT_LANGUAGE
        };
        this._onSubmitValue = this._onSubmitValue.bind(this);
        this._onLanguageItemSelect = this._onLanguageItemSelect.bind(this);
    }
    /**
     * Callback to be invoked when the value of the link input is submitted.
     *
     * @returns {boolean}
     */
    _onSubmitValue() {
        if (this.state.currentLanguage !== this.state.newLanguage) {
            i18next.changeLanguage(this.state.newLanguage);
        }
        // This is not required as auto hide is enabled
        // this.props.dispatch(hideDialog());
    }
    _onLanguageItemSelect(e) {
        const language = e.target.value;
        this.setState({
            newLanguage: language
        });
    }
    _renderLanguageSelect() {
        const { languages, t } = this.props;
        const languageItems = languages.map((language) => {
            return {
                value: language,
                label: t(`languages:${language}`)
            };
        });
        return (React.createElement(Select, { id: 'more-language-select', label: t('settings.language'), onChange: this._onLanguageItemSelect, options: languageItems, value: this.state.newLanguage }));
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     */
    render() {
        const { t } = this.props;
        return (React.createElement(Dialog, { disableAutoHideOnSubmit: false, ok: {
                translationKey: 'dialog.Ok'
            }, onSubmit: this._onSubmitValue, titleKey: 'toolbar.language' }, this._renderLanguageSelect()));
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function mapStateToProps(state) {
    return {
        languages: LANGUAGES
    };
}
export default translate(connect(mapStateToProps)(LanguageDialog));
